const Joi = require("joi");
const ValidationTranslateFile = require("../../src/config/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const sendPhotoSchema = (data) => {
  const schema = Joi.object({
    inmatesId: Joi.number().min(1).required().messages({
      "number.base": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "number.min": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "any.only": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "any.required": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "string.empty": currentLang?.ValidationSchema?.Please_Choose_Inmate,
    }),

    subject: Joi.string().trim().required().messages({
      "any.required": currentLang?.ValidationSchema?.Please_enter_subject,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_subject,
    }),
    file: Joi.string().messages({
      "any.required": currentLang?.ValidationSchema?.Please_upload_an_image,
      "string.empty": currentLang?.ValidationSchema?.Please_upload_an_image,
    }),

    // Accepting Base64 string instead of file object
    // file: Joi.string()
    //   .required()
    //   .custom((value, helpers) => {
    //     if (!value || value.trim() === "") {
    //       return helpers.message("Please upload an image.");
    //     }

    //     const isBase64 = /^([A-Za-z0-9+/=])+$/.test(value); // Check if it's a valid Base64 string
    //     if (!isBase64) {
    //       return helpers.message("Invalid image format.");
    //     }

    //     return value;
    //   })
    //   .messages({
    //     "any.required": "Please upload an image.",
    //     "string.empty": "Please upload an image.",
    //   }),
  }).unknown(true); // Allow unknown keys in the object

  return schema.validate(data, { abortEarly: false });
};

module.exports = sendPhotoSchema;
